import $ from 'jquery';

import { $Elements, Events, Classes } from './constants';
import { disableBodyScroll, scrollTo, enableBodyScroll } from './helpers';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Menu ----------

	$Elements.document.on('click', '.menu-toggle, a[href="#menu-wrapper"]', function(e) {
		e.preventDefault();

		if($Elements.body.hasClass(Classes.menuOpen)) {
			$Elements.body.removeClass(Classes.menuOpen);
			enableBodyScroll();
		}
		else {
			$Elements.body.addClass(Classes.menuOpen);
			disableBodyScroll();
		}
	});

	$Elements.document.on('click', '.menu-overlay', function(e) {
		e.preventDefault();

		$('.menu-toggle').trigger('click');
	});

	$Elements.document.on('click', '.navbar-menu a, .menu-wrapper a', function(e) {

		const linkTarget = this.getAttribute('href');
		const sectionTarget = linkTarget.substring(linkTarget.lastIndexOf('#'), linkTarget.length);

		if(sectionTarget.substring(0, 1) === '#') {

			e.preventDefault();

			const section = $(sectionTarget);

			if(section.length) {

				window.history.replaceState(null, null, sectionTarget);

				$Elements.body.removeClass(Classes.menuOpen);
				enableBodyScroll()
				scrollTo(section);


			}
			else if(sectionTarget !== '#') {
				window.location = linkTarget;
			}
		}

	});

	$Elements.window.on('load', function() {

		const linkTarget = window.location.href;
		const sectionTarget = linkTarget.substring(linkTarget.lastIndexOf('#'), linkTarget.length);

		if(sectionTarget.substring(0, 1) === '#') {

			const section = $(sectionTarget);

			if(section.length) {
				scrollTo(section, 0);
			}
		}

		if ($('body').hasClass('single')) {
			$('li.menu-item:has(a[title="Nos vins"])').addClass('active');
		}

	});

});
